// new okendo custom code
// Adjust the main widget on product pages to thicken the line for the slightly "True to Size" indicator
window.addEventListener('load', function() {
    setTimeout(() => {
      let mainWidgetSizeBar = document.querySelector("#product-reviews .oke-w-header-content .oke-barBlocks--centered");
      if(mainWidgetSizeBar){
  
          let precentageText = document.querySelector("#product-reviews .oke-w-header-content .oke-attrBar-title .oke-a11yText").innerText;
          if(precentageText.includes("0.0")){
            
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("min-width", "30px", "important");
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("transform", "translateX(-13px)", "important");
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine").style.setProperty("background", "transparent", "important");
          }
      }
    const oke_select = document.querySelector("#oke-sortSelect--reviews");
    if (oke_select){
        const optionToHide = oke_select.querySelector('option[value*="has_media"]');
        if (optionToHide) {
          optionToHide.style.display = 'none'; 
          optionToHide.hidden = true; 
        }
    }

    // Extract reviewAggregate.attributeRatings.value from JSON script
    let okendoScript = document.querySelector('#product-reviews [data-oke-metafield-data]');
    let shadingBar = document.querySelectorAll(".oke-w-barAttributes--stacked .oke-barBlocks-bg-shading");
    if (okendoScript && shadingBar.length) {
      try {
        let jsonData = JSON.parse(okendoScript.textContent || "{}");
        let attributeRatingsValue = jsonData?.reviewAggregate?.attributeRatings?.[0]?.value;

        if (typeof attributeRatingsValue === "number") {
          if (attributeRatingsValue > -0.15 && attributeRatingsValue <= 0.15) { // True to Size
            shadingBar.forEach(el => el.style.setProperty("margin-left", "calc( 50% - 15px)", "important"));
          } else if (attributeRatingsValue > -0.5 && attributeRatingsValue <= -0.15) { // runs a bit small
            shadingBar.forEach(el => el.style.setProperty("margin-left", "calc( 25% - 15px)", "important"));
          } else if (attributeRatingsValue > -1 && attributeRatingsValue <= -0.5) { // runs small
            shadingBar.forEach(el => el.style.setProperty("margin-left", "0", "important"));
          } else if (attributeRatingsValue > 0.15 && attributeRatingsValue <= 0.5) { // runs a bit big
            shadingBar.forEach(el => el.style.setProperty("margin-left", "calc( 75% - 15px)", "important"));
          } else if (attributeRatingsValue > 0.5 && attributeRatingsValue <= 1) { // runs big
            shadingBar.forEach(el => el.style.setProperty("margin-left", "calc( 100% - 30px)", "important"));
          }

          shadingBar.forEach(el => el.style.setProperty("transform", "none", "important"));
        }
      } catch (e) {
        console.error('Error parsing JSON from data-oke-metafield-data:', e);
      }
    }

    }, 500);
})
